import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { UserContract } from 'apis/merchant-onboarding-service/types';
import WaiterOrder from 'common/illustrations/WaiterOrder';
import { Typography as T } from 'common/typography';

type Props = {
  userContracts: UserContract[];
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (width <= 640px) {
    gap: 16px;
  }
`;

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  max-width: 600px;
  height: 106px;
  border-radius: 8px;
  background-color: ${colors.wolt8};
  padding-block: 16px;
  padding-inline: 16px;

  @media (width <= 640px) {
    height: 100%;
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
`;

const StyledLink = styled.a`
  @media (width <= 640px) {
    a {
      width: 100%;
    }
  }
`;

const StyledIllustration = styled(WaiterOrder)`
  max-height: 78px;
`;

const Content = styled.div`
  flex-grow: 1;
`;

const StyledHeading = styled(T.Heading6)`
  color: ${cbSemanticCssVars.textPrimary};
  font-size: 18px;
`;

const StyledBody = styled(T.Body3)`
  font-size: 14px;
  color: ${cbSemanticCssVars.textSecondary};
`;

const StyledButton = styled(Button)`
  width: 135px;
  height: 56px;
  white-space: break-spaces;
  flex-shrink: 0;

  @media (width <= 640px) {
    width: 100%;
    height: 36px;
  }
`;

const Contracts = ({ userContracts }: Props) => {
  return (
    <Root>
      {userContracts.map(userContract => (
        <Card>
          <StyledIllustration />
          <Content>
            <StyledHeading>
              <FormattedMessage id="merchant-sign-up.contract-links.wolt-partner-contract" />
            </StyledHeading>
            <StyledBody>{userContract.merchantName}</StyledBody>
          </Content>
          <StyledLink href={userContract.signingUrl} target="_blank">
            <StyledButton variant={'blue'} size={'small'}>
              <FormattedMessage id="merchant-sign-up.contract-links.review-and-sign" />
            </StyledButton>
          </StyledLink>
        </Card>
      ))}
    </Root>
  );
};

export default Contracts;
